import React, { useMemo } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { formValueSelector } from "redux-form";

import { CustomDropdownByValue, CustomInput } from "components";
import { FieldWithReadOnlyMode } from "components/formFields";
import { FormColumn, FormRow } from "components/layout";
import { dropdownValuesService } from "services";
import { trimNormalizer, required } from "validators";

import { ABAField, DDAField } from "./fields";

type ACHFieldsProps = {
	loading: boolean;
	formName: string;
	isEditable: boolean;
};

export const AchFields = ({
	loading,
	formName,
	isEditable,
}: ACHFieldsProps) => {
	const { data: accountTypes, isLoading: isLoadingAccountTypes } = useQuery(
		"accountType",
		dropdownValuesService.getAccountTypes,
	);

	const selector = formValueSelector(formName);
	const formValue = useSelector(state => selector(state, "payment_info"));

	const accountType = useMemo(
		() =>
			accountTypes?.find(
				type => type.value === +formValue?.ach?.account_type,
			)?.displayName,
		[accountTypes, formValue?.ach?.account_type],
	);

	return (
		<>
			<FormRow>
				<FormColumn>
					<ABAField
						value={formValue?.ach?.aba}
						loading={loading}
						isEditable={isEditable}
					/>
				</FormColumn>
				<FormColumn>
					<FieldWithReadOnlyMode
						component={CustomDropdownByValue}
						labelName="displayName"
						smLabel={5}
						smSelect={7}
						label="Account Type"
						name="account_type"
						items={accountTypes}
						loading={loading || isLoadingAccountTypes}
						validate={required}
						readOnlyProps={{
							isEditable,
							value: accountType,
						}}
					/>
				</FormColumn>
			</FormRow>
			<FormRow>
				<FormColumn>
					<DDAField
						value={formValue?.ach?.dda}
						loading={loading}
						isEditable={isEditable}
					/>
				</FormColumn>
				<FormColumn>
					<FieldWithReadOnlyMode
						label="Payee Name"
						component={CustomInput}
						smLabel={5}
						smSelect={7}
						type="text"
						validate={[required]}
						name="payee_name"
						blurLoading={loading}
						normalizeOnBlur={trimNormalizer}
						readOnlyProps={{
							isEditable,
							value: formValue?.ach?.payee_name,
						}}
					/>
				</FormColumn>
			</FormRow>
		</>
	);
};
